.container
    .row
        .col-md-12
            if auth.provider == 'password' || auth.provider == 'google.com'
                include navbar
